import { maxWidth, media } from 'ui/styles/theme';

export const withContainer = {
  container: {
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  wrapper: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [media.mobile]: {
      maxWidth: maxWidth.mobile,
    },
    [media.desktop]: {
      maxWidth: maxWidth.desktop,
    },
  },
};
